import { css } from 'styled-components';
import { whenHovered, theme, whenFocused, whenActive } from "../../theme";
import { lighten } from 'polished';
import { IconBefore, IconAfter } from "./Icons";
export function linkVariant() {
  return css(["padding:0;background:none;", ";", "{margin-left:0;}", "{margin-right:0;}", "{", ";}", "{text-decoration:underline;box-shadow:none !important;", ";}&[aria-expanded='true'],", "{", ";}", ""], baseStyles, IconBefore, IconAfter, whenHovered, hoverStyles, whenFocused, focusStyles, whenActive, activeStyles, function (p) {
    return p.disabled && "\n      pointer-events: none;\n      color: ".concat(theme.colors.palette.tintA30, ";\n    ");
  });
}

function baseStyles(p) {
  if (p.$color === 'primary') {
    return css(["color:", ";"], theme.colors.palette.brandPrimary);
  }

  if (p.$color === 'error') {
    return css(["color:", ";"], theme.colors.palette.alertError);
  }

  return css(["color:", ";"], theme.colors.palette.tintA80);
}

function hoverStyles(p) {
  if (p.$color === 'primary') {
    return css(["color:", ";"], lighten(0.06, theme.colors.palette.brandPrimary));
  }

  if (p.$color === 'error') {
    return css(["color:", ";"], lighten(0.08, theme.colors.palette.alertError));
  }

  return css(["color:", ";"], theme.colors.palette.tintA100);
}

function focusStyles(p) {
  if (p.$color === 'primary') {
    return css(["color:", ";"], theme.colors.palette.brandPrimary);
  }

  if (p.$color === 'error') {
    return css(["color:", ";"], theme.colors.palette.alertError);
  }

  return css(["color:", ";"], theme.colors.palette.tintA100);
}

function activeStyles(p) {
  if (p.$color === 'primary') {
    return css(["color:", ";"], theme.colors.palette.brandPrimary);
  }

  if (p.$color === 'error') {
    return css(["color:", ";"], theme.colors.palette.alertError);
  }

  return css(["color:", ";"], theme.colors.palette.tintA90);
}